import sentry from 'legacy/utils/sentry'

import { createAgnosticHttpClient } from 'auth/infra/createAgnosticHttpClient'

import {
  ShipmentRepository,
  type RescheduleOpenDockWarehouseAppointmentParams,
} from '../infra/ShipmentRepository'

export type RescheduleOpenDockWarehouseAppointmentUseCaseParams = Omit<
  RescheduleOpenDockWarehouseAppointmentParams,
  'config'
>

export type RescheduleOpenDockWarehouseAppointmentFactoryDependencies = {
  shipmentRepository: ShipmentRepository
}

export function rescheduleOpenDockWarehouseAppointmentFactory({
  shipmentRepository,
}: RescheduleOpenDockWarehouseAppointmentFactoryDependencies) {
  return async function submit(
    params: RescheduleOpenDockWarehouseAppointmentUseCaseParams,
    config?: { signal?: AbortSignal }
  ) {
    const { shipmentUUID, stopIndex, misschedulingReason, misschedulingNote, dockId, start } =
      params
    try {
      return await shipmentRepository.rescheduleOpenDockWarehouseAppointment({
        shipmentUUID,
        stopIndex,
        misschedulingReason,
        misschedulingNote,
        dockId,
        start,
        config,
      })
    } catch (error) {
      sentry.log(error)
      throw new Error('Could not reschedule appointment', { cause: error as Error })
    }
  }
}

export function rescheduleOpenDockWarehouseAppointment(
  params: RescheduleOpenDockWarehouseAppointmentUseCaseParams,
  config?: { signal?: AbortSignal }
) {
  const httpClient = createAgnosticHttpClient()
  const shipmentRepository = new ShipmentRepository({ httpClient })
  const submit = rescheduleOpenDockWarehouseAppointmentFactory({ shipmentRepository })

  return submit(params, config)
}
